module.exports = __webpack_public_path__ + "static/media/1.12d3c1f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/02/projects/01/1.jpg
// module id = 403
// module chunks = 0